export default function(value: number | string): string {
  const number: number = Number(value);

  if (window.isNaN(number)) {
    return <string> value;
  }

  return number.toFixed(2);
}
